module.exports = __webpack_public_path__ + "img/pk_live_bg.3c5d08.jpg";